var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"search-input",attrs:{"id":_vm.id},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.onChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }